export default "__VITE_ASSET__Di2o67rG__"